import {ApiBridgeI} from "./bridges/api-bridge-i";
import {Observable} from "rxjs";
import {TemplateRef} from "@angular/core";

export const EXT_KEY_USAGE_STAMP: string[] = ["Цифрова печатка", "1.2.804.2.1.1.1.3.9"];

/**
 * Визначає тип власника коду (ЄДРПОУ юр. особи чи РНОКПП/паспорт фіз. особи)
 * за форматом самого коду. Використовується і для класифікації ключа підпису
 * (за subjEDRPOUCode/subjDRFOCode сертифіката), і для класифікації коду
 * організації (`DahSignAction.erdpou`), щоб звірка в hashSign() спиралась на
 * той самий формат, що і визначення типу ключа в мостах.
 */
export function classifyCode(code: string | undefined | null): "jur" | "fiz" | undefined {
    if (!code) {
        return undefined;
    }
    if (/^\d{8}$/.test(code)) {
        return "jur";
    }
    if (/(^\d{9,10}$)|(^[A-ZА-Я]{2}\d{6}$)/.test(code)) {
        return "fiz";
    }
    return undefined;
}

export interface DahSignAction {

    type: 'hashSign';
    signCount?: number,
    viewOnly?: boolean,
    templateRef?: TemplateRef<any>;
    templateBeforeRef?: TemplateRef<any>;
    diia?: boolean;
    file_name?: string | Record<string, string>;
    stampOnly?: boolean;
    blockSignStamp?: boolean;
    blockSignStampOnly?: boolean;
    libInit?: () => void;

    getSignData?: (isAppend?: any, keys?: InitKey[]) => Observable<Uint8Array | string | Record<string, Uint8Array> | Record<string, string>>;
    getDiiaLink?: () => Observable<string>;
    stayOpen?: boolean;

    erdpou?: string;
    serial?: string;
}

export interface InitKey {
    id: string;
    inn: string;
    code: string;
    type: "jur" | "fiz";
    fio: {
        full: string;
    },
    companyName: string;
    position: string;
    issuer: string;
    serial: string;
    title: string;
    valid: boolean;
    bridgeType: 'widget';
    bridge: ApiBridgeI;
    isStamp?: boolean;
    selected?: boolean;
    isOpen?: boolean;
    keyIndex?: number;
}

export interface VerifyData {
    subjCN: string,
    subjFullName: string,
    subjTitle: string,
    subjOrg: string,
    subjDRFOCode: string,
    subjEDRPOUCode: string,
    issuerCN: string,
    signTimeStamp: string,
    serial?: string
}
